module.exports = __webpack_public_path__ + "img/bggl.531d439a.png";